<template>
    
  <div class="social-upload-root">
    <v-stepper v-model="e1" elevation="0">
        <div class="stepperheader">
            <v-stepper-step :complete="e1 > 1" step="1" class="pa-2">
                {{ $store.getters.t('social.upload.step.input') }}
            </v-stepper-step>

            <v-divider class="divider-20-36"></v-divider>

            <v-stepper-step :complete="e1 > 2" step="2" class="pa-2">
                {{ $store.getters.t('social.upload.step.review') }}
            </v-stepper-step>

            <v-divider class="divider-20-36"></v-divider>

            <v-stepper-step step="3" class="pa-2">
                {{ $store.getters.t('social.upload.step.complete') }}
            </v-stepper-step>
        </div>

        <v-stepper-items>
            <v-stepper-content class="pa-0 mb-0" step="1">
                <div class="upload-content">
                    <div class="left">
                    <div class="upload-left">
                        <div class="upload-container">
                        <v-img :src="imageSrcComputed" :contain="true" />
                        <div v-if="runtimeComputed" class="video-duration">{{ runtimeComputed }}</div>
                        </div>
                    </div>

                    <div class="social_card_group">
                        <v-card class="pa-3" outlined @click="selectedCard = 'youtube'" :class="{ 'selected': selectedCard === 'youtube' }">
                        <div class="social_card">
                            <v-img src="@/styles/youtube.png" class="social_card_icon"/>
                            <h4>YouTube</h4>
                        </div>
                        </v-card>
                        <v-card class="pa-3" disabled outlined @click="selectedCard = 'instgram'" :class="{ 'selected': selectedCard === 'instgram' }">
                        <div class="social_card">
                            <v-img src="@/styles/instgram.png" />
                            <h4>Instagram</h4>
                        </div>
                        <v-chip label color="gray" x-small class="chip_posi">
                            {{ $store.getters.t('social.upload.status.preparing') }}
                        </v-chip>
                        </v-card>
                    </div>
                    </div>

                    <!-- 선택 안 했을 때 -->
                    <div v-if="selectedCard === 'none'" class="detail_Card nonetype">
                        <v-card outlined class="media_none">
                            <div class="media_none_contents">
                            <img src="@/styles/social_error.png" />
                            <h3>{{ $store.getters.t('social.upload.select_media_title') }}</h3>
                            <hr/>
                            <div class="txt" v-html="$store.getters.t('social.upload.select_media_description')"></div>
                            </div>
                        </v-card>
                    </div>

                    <!-- YouTube -->
                    <div v-else-if="selectedCard === 'youtube'" class="detail_Card youtubetype">
                    <!-- 미연동 UI -->
                    <template v-if="integrationsLoading">
                        <v-card outlined class="media_none">
                            <div class="media_none_contents">
                            <img src="@/styles/youtube.png" />
                            <h3>{{ $store.getters.t('social.upload.youtube.checking_title') }}</h3>
                            <hr/>
                            <div class="txt" v-html="$store.getters.t('social.upload.youtube.checking_description')"></div>
                            </div>
                        </v-card>
                    </template>
                    <template v-else-if="!googleLogin">
                        <v-card outlined class="media_none">
                            <div class="media_none_contents">
                            <img src="@/styles/youtube.png" />
                            <h3>{{ $store.getters.t('social.upload.youtube.connect_title') }}</h3>
                            <hr/>
                            <div class="txt">
                                <template v-if="integrationsError">
                                    {{ integrationsError }}
                                </template>
                                <template v-else>
                                    <span v-html="$store.getters.t('social.upload.no_integration_description')"></span>
                                </template>
                            </div>
                            <!-- 기존 버튼: 주석 처리 -->
                                <!-- <TextButton :buttonText="$store.getters.t('연결하기')" isPrimary @click="connectSelected" /> -->

                                <!-- 추가 버튼: 클릭 시 즉시 폼 열기 -->
                                <TextButton
                                    :buttonText="$store.getters.t('social.integration.action.connect')"
                                    isPrimary
                                    @click="connectYouTube"
                                />
                            </div>
                        </v-card>
                    </template>

                    <!-- 연동됨: 기존 폼 -->
                    <template v-else>
                        <div class="type-toggle mb-3">
                            <v-card outlined class="type-card" :class="{ active: selectedVideoType === 'shorts' }" @click="selectedVideoType = 'shorts'">
                                <div class="type-card-content">
                                    <div class="type-title">{{ $store.getters.t('social.upload.youtube.type.shorts') }}</div>
                                    <div class="type-sub">{{ $store.getters.t('social.upload.youtube.type.shorts_desc') }}</div>
                                </div>
                            </v-card>
                            <v-card outlined class="type-card" :class="{ active: selectedVideoType === 'video' }" @click="selectedVideoType = 'video'">
                                <div class="type-card-content">
                                    <div class="type-title">{{ $store.getters.t('social.upload.youtube.type.standard') }}</div>
                                    <div class="type-sub">{{ $store.getters.t('social.upload.youtube.type.standard_desc') }}</div>
                                </div>
                            </v-card>
                        </div>

                        <h4>{{ $store.getters.t('social.upload.channel_label') }} <span class="required-mark">*</span></h4>
                        <AppSelectList
                            v-model="selectedChannel"
                            :items="channelItems"
                            variant="channel"
                            :placeholder="$store.getters.t('social.upload.channel_placeholder')"
                            :item-height="44"
                            :show-items-count="4.5"
                            @channel-add="onAddChannel"
                        />

                        <h4>{{ $store.getters.t('social.upload.title_label') }} <span class="required-mark">*</span></h4>
                        <AppTextField v-model="uploadTitle" />

                        <div class="description">
                            <h4>{{ $store.getters.t('social.upload.description_label') }}</h4>
                            <v-textarea
                                :placeholder="$store.getters.t('social.upload.description_placeholder')"
                                dense
                                outlined
                                v-model="uploadDescript"
                                @input="onDescriptionInput"
                                color="black"
                                height="60px"
                            />
                        </div>

                        <div class="option_list">
                            <div>
                                <h4>{{ $store.getters.t('social.upload.visibility_label') }} <span class="required-mark">*</span></h4>
                                <AppSelectList
                                    v-model="uploadStatus"
                                    :items="translatedPrivacyItems"
                                    variant="privacy"
                                    :placeholder="$store.getters.t('social.upload.visibility_placeholder')"
                                    :item-height="44"
                                    :show-items-count="5.5"
                                    :clearable="false"
                                    />
                            </div>

                            <div>
                                <h4>{{ $store.getters.t('social.upload.category_label') }}</h4>
                                <AppSelectList
                                    v-model="uploadCate"
                                    :items="youtubeCategoryItems"
                                    :placeholder="$store.getters.t('social.upload.category_placeholder')"
                                    :item-height="40"
                                    :show-items-count="4.5"
                                    />
                            </div>
                            <div>
                                <h4>{{ $store.getters.t('social.upload.made_for_kids_label') }} <span class="required-mark">*</span></h4>
                                <AppSelectList
                                    v-model="madeForKids"
                                    :items="madeForKidsSelectItems"
                                    :placeholder="$store.getters.t('social.upload.made_for_kids_placeholder')"
                                    :item-height="44"
                                    :show-items-count="2.5"
                                    :clearable="false"
                                />
                            </div>
                        </div>
                    </template>
                    </div>

                    <!-- Instagram -->
                    <div v-else-if="selectedCard === 'instgram'" class="detail_Card instagramtype">
                        <!--프로패셔널 계정 미연동  UI-->
                    <template v-if="instagramError">
                        <v-card outlined class="media_error">
                            <div class="media_error_contents">
                            <h3 class="txt mb-3" v-html="$store.getters.t('social.upload.instagram.requirements_title')"></h3>

                            <ol class="error-steps">
                                <li class="mb-3">
                                <div class="step-title">{{ $store.getters.t('social.upload.instagram.step1_title') }}</div>
                                <div class="step-desc">
                                    {{ $store.getters.t('social.upload.instagram.step1_desc') }}
                                </div>
                                <a target="_blank" class="step-link">{{ $store.getters.t('social.upload.instagram.instructions_link') }}</a>
                                </li>

                                <li>
                                <div class="step-title">{{ $store.getters.t('social.upload.instagram.step2_title') }}</div>
                                <div class="step-desc">
                                    {{ $store.getters.t('social.upload.instagram.step2_desc') }}
                                </div>
                                <a target="_blank" class="step-link">{{ $store.getters.t('social.upload.instagram.instructions_link') }}</a>
                                </li>
                            </ol>
                            </div>
                        </v-card>
                    </template>
                    <!-- 미연동 UI -->
                    <template v-else-if="!instagramLogin">
                        <v-card outlined class="media_none">
                            <div class="media_none_contents">
                                <img src="@/styles/instgram.png" />
                                <h3>{{ $store.getters.t('social.upload.instagram.connect_title') }}</h3>
                                <hr/>
                                <div class="txt">
                                    <span v-html="$store.getters.t('social.upload.no_integration_description')"></span>
                                </div>

                                <TextButton
                                    :buttonText="$store.getters.t('social.integration.action.connect')"
                                    isPrimary
                                    @click="instagramLogin = true"
                                />
                            </div>
                        </v-card>
                    </template>

                    <!-- 연동됨: 기존 폼 -->
                    <template v-else>
                        <div class="type-toggle mb-3">
                            <v-card outlined class="type-card" :class="{ active: selectedInstagramType === 'reels' }" @click="selectedInstagramType = 'reels'">
                                <div class="type-card-content">
                                    <div class="type-title">{{ $store.getters.t('social.upload.instagram.type.reels') }}</div>
                                    <div class="type-sub">{{ $store.getters.t('social.upload.instagram.type.reels_desc') }}</div>
                                </div>
                            </v-card>

                            <v-card outlined class="type-card" :class="{ active: selectedInstagramType === 'feed' }" @click="selectedInstagramType = 'feed'">
                                <div class="type-card-content">
                                    <div class="type-title">{{ $store.getters.t('social.upload.instagram.type.feed') }}</div>
                                    <div class="type-sub">{{ $store.getters.t('social.upload.instagram.type.feed_desc') }}</div>
                                </div>
                            </v-card>
                        </div>

                        <v-checkbox :label="$store.getters.t('social.upload.instagram.share_to_feed')" style="height: 30px;" />

                        <h4>{{ $store.getters.t('social.upload.title_label') }}</h4>
                        <AppTextField v-model="uploadTitle" />

                        <div class="description">
                            <h4>설명</h4>
                            <v-textarea
                                placeholder="게시물 설명과 해시태그를 입력하세요."
                                dense
                                outlined
                                v-model="uploadDescript"
                                @input="onDescriptionInput"
                                color="black"
                                height="60px"
                                style="height: 60px !important;"
                            />
                            <span class="type-sub">최대 2,200자 해시태그 30개 제한</span>
                        </div>

                        <div style="height:12px;"></div>

                        <!-- 위치 & 사람 태그 섹션 -->
                        <div class="meta-head">
                            <h4>위치 추가</h4>
                        </div>
                        <!-- 위치 -->
                        <div class="meta-block">
                            <!-- 선택됨 뱃지 -->
                            <div v-if="selectedLocation" class="chips">
                                <v-chip label class="chip-item">
                                <v-icon left small>mdi-map-marker</v-icon>
                                {{ selectedLocation.name }}
                                <v-icon right small class="chip-close" @click.stop="clearLocation">mdi-close</v-icon>
                                </v-chip>
                            </div>

                            <!-- 선택 없음 안내 -->
                            <div v-else class="meta-empty">선택된 위치가 없습니다.</div>

                            <!-- 위치 추가 버튼 -->
                            <div class="meta-actions">
                                <v-btn small outlined class="meta-actions-btn" block
                                    :disabled="!!selectedLocation"
                                    @click="isLocationDialogOpen = true">
                                <v-icon left small>mdi-map-marker-plus</v-icon>위치 추가
                                </v-btn>
                            </div>
                        </div>

                        <!-- 사람 태그 -->
                        <div class="meta-head">
                            <h4>태그</h4>
                            <span class="meta-hint">{{ taggedPeople.length }}/20명</span>
                        </div>
                        <div class="meta-block">

                            <!-- 태그된 사람 뱃지들 -->
                            <div class="chips group" v-if="taggedPeople.length">
                                <v-chip
                                    v-for="u in taggedPeople"
                                    :key="u.id"
                                    label
                                    class="chip-item chip-person"
                                >
                                    <v-avatar left size="20">
                                        <v-img :src="thumbsMap[u.thumb] ? thumbsMap[u.thumb] : thumbsMap['thum01']" contain />
                                    </v-avatar>
                                    <div class="chip-text">
                                        <span class="chip-name">{{ u.name }}</span>
                                        <span class="chip-handle">{{ u.handle }}</span>
                                        <v-img v-if="isOfficial(u)" :src="officialIcon" class="official-mark" width="14" height="14" contain />
                                    </div>
                                    <v-icon right small class="chip-close" @click.stop="removeTaggedPerson(u.id)">mdi-close</v-icon>
                                </v-chip>
                            </div>

                            <div class="meta-empty" v-else>태그된 사람이 없습니다.</div>

                            <!-- 사람 태그 추가 버튼 -->
                            <div class="meta-actions">
                                <v-btn small outlined class="meta-actions-btn" block
                                    :disabled="taggedPeople.length >= 20"
                                    @click="isTagDialogOpen = true">
                                <v-icon left small>mdi-account-plus</v-icon> 사람 태그하기
                                </v-btn>
                            </div>
                        </div>

                        <!-- 위치 선택 모달 -->
                        <AppDialog v-model="isLocationDialogOpen" :persistent="false">
                        <template #title><span style="font-weight:bold;font-size:18px;">위치 검색</span></template>
                        <template #close><v-btn icon @click="isLocationDialogOpen=false"><v-icon>mdi-close</v-icon></v-btn></template>
                        <template #content>
                            <AppTextField v-model="locationQuery" placeholder="장소명 또는 주소" class="mb-3" />
                            <div class="list-wrap">
                            <v-list dense>
                                <v-list-item v-for="loc in filteredLocations" :key="loc.id" @click="selectLocation(loc)">
                                <v-icon class="mr-2">mdi-map-marker</v-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="mono-ellipsis">{{ loc.name }}</v-list-item-title>
                                    <v-list-item-subtitle class="mono-ellipsis">{{ loc.address }}</v-list-item-subtitle>
                                </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            </div>
                        </template>
                        </AppDialog>

                        <!-- 사람 태그 모달 -->
                        <AppDialog v-model="isTagDialogOpen" :persistent="false">
                        <template #title><span style="font-weight:bold;font-size:18px;">사람 태그하기</span></template>
                        <template #close><v-btn icon @click="isTagDialogOpen=false"><v-icon>mdi-close</v-icon></v-btn></template>
                        <template #content>
                            <AppTextField v-model="peopleQuery" placeholder="이름/핸들 검색" class="mb-3" />
                            <div class="list-wrap">
                            <v-list dense>
                                <v-list-item
                                    v-for="p in filteredPeople"
                                    :key="p.id"
                                >
                                    <div class="thum_cover mr-3">
                                        <v-img
                                            :src="thumbsMap[p.thumb] ? thumbsMap[p.thumb] : thumbsMap['thum01']"
                                            width="30"
                                            height="30"
                                            contain
                                        />
                                    </div>
                                    
                                    <v-list-item-content>
                                        <v-list-item-title class="mono-ellipsis">
                                            <span>{{ p.name }}</span>
                                            <v-img v-if="isOfficial(p)" :src="officialIcon" class="official-mark ml-1" width="14" height="14" contain />
                                        </v-list-item-title>
                                        <v-list-item-subtitle class="mono-ellipsis">{{ p.handle }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn icon small color="grey darken-1"
                                            v-if="!isAlreadyTagged(p.id)"
                                            :disabled="taggedPeople.length >= 20"
                                            @click.stop="addTaggedPerson(p)">
                                        <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                        <v-btn icon small color="grey darken-1"
                                            v-else
                                            @click.stop="removeTaggedPerson(p.id)">
                                        <v-icon>mdi-minus</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                            </div>
                            <div v-if="taggedPeople.length >= 20" class="limit-hint">
                                <v-icon small color="red">mdi-information-outline</v-icon>
                                {{ $store.getters.t('social.upload.tag.limit_hint') }}
                            </div>
                        </template>
                        <template #actions>
                            <v-spacer />
                            <TextButtonBlock :buttonText="$store.getters.t ? $store.getters.t('common.action.clear_all') : '전체취소'" :disabled="!taggedPeople.length" @click="clearAllTagged"></TextButtonBlock>
                            <TextButtonBlock isPrimary :buttonText="$store.getters.t ? $store.getters.t('common.action.done') : '완료'" depressed @click="isTagDialogOpen=false"></TextButtonBlock>
                        </template>
                        </AppDialog>

                    </template>
                    
                    </div>
                </div>

                <div class="btn-group">
                    <TextButtonBlock :buttonText="$store.getters.t ? $store.getters.t('common.action.cancel') : '취소'" @click="handleCloseRequested" />
                    <TextButtonBlock :buttonText="$store.getters.t ? $store.getters.t('common.action.next') : '다음'" @click="handleNextStep" isPrimary />
                </div>
                </v-stepper-content>

            <v-stepper-content class="pa-0 mb-0" step="2">
                <div class="upload-content">
                    <div class="left">
                        <div class="upload-left">
                            <div class="upload-container">
                                <v-img :src="imageSrcComputed" :contain="true" />
                                <div v-if="runtimeComputed" class="video-duration">{{ runtimeComputed }}</div>
                            </div>
                        </div>

                        <v-card elevation="0" class="summary-card">
                            <div class="summary-row">
                                <span class="summary-key">{{ $store.getters.t('social.upload.summary.platform') }}</span>
                                <span class="summary-val">{{ platformLabel }}</span>
                            </div>
                            <div class="summary-row">
                                <span class="summary-key">{{ $store.getters.t('social.upload.summary.type') }}</span>
                                <span class="summary-val">{{ videoTypeLabel }}</span>
                            </div>
                            <div class="summary-row">
                                <span class="summary-key">{{ $store.getters.t('social.upload.summary.title') }}</span>
                                <span class="summary-val summary-ellipsis" :title="uploadTitle">{{ uploadTitle || '-' }}</span>
                            </div>
                            <div v-if="selectedCard === 'youtube'" class="summary-row">
                                <span class="summary-key">{{ $store.getters.t('social.upload.summary.visibility') }}</span>
                                <span class="summary-val">{{ privacyLabel }}</span>
                            </div>
                            <div v-if="selectedChannelLabel" class="summary-row">
                                <span class="summary-key">{{ $store.getters.t('social.upload.channel_label') }}</span>
                                <span class="summary-val">{{ selectedChannelLabel }}</span>
                            </div>
                        </v-card>
                    </div>

                    <div class="detail_Card">
                        
                        <v-card outlined class="media_none">
                            <div class="media_none_contents">
                                <div class="success-circle mx-auto mb-3">
                                    <v-icon color="green darken-2" large>mdi-check</v-icon>
                                </div>
                                <h3>{{ $store.getters.t('social.upload.review.ready_title') }}</h3>
                                <hr/>
                                <div class="txt">{{ $store.getters.t('social.upload.review.ready_description') }}</div>
                            </div>
                        </v-card>
                    </div>
                </div>

                    <div class="upload-action-row">
                        <TextButtonBlock :buttonText="$store.getters.t('common.action.previous')" :width="'49.5%'" @click="e1 = 1" />
                        <div class="upload-cta-wrapper ml-2">
                            <TextButtonBlock
                                :disabled="btnStatus || !canUseSocialPublish"
                                :buttonText="$store.getters.t('common.action.upload')"
                                @click="socialUpload"
                                :width="'49.2%'"
                                isPrimary
                            />
                            <div v-if="!canUseSocialPublish" class="upload-lock-overlay">
                                <v-icon small color="#92400e" class="mr-1">mdi-lock</v-icon>
                                <span>{{ lockBadgeLabel }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="!canUseSocialPublish" class="plan-hint mt-4">
                        {{ upgradeCopy }}
                    </div>
            </v-stepper-content>

            <v-stepper-content class="pa-0 mb-0 upload-step-complete" step="3">
                <div class="upload-complete-card">
                    <div class="success-circle">
                        <v-icon color="green darken-2" large>mdi-check</v-icon>
                    </div>
                    <h3 class="complete-title">{{ $store.getters.t ? $store.getters.t('social.upload.complete.title') : '업로드 요청이 완료되었습니다.' }}</h3>
                    <p class="complete-desc">
                        {{ $store.getters.t ? $store.getters.t('social.upload.complete.description') : '선택한 채널로 업로드 작업이 큐에 등록되었습니다. 진행 상황은 우측 하단 패널에서 확인할 수 있습니다.' }}
                    </p>
                    <TextButtonBlock
                        :buttonText="$store.getters.t ? $store.getters.t('common.action.close') : '닫기'"
                        :width="'100%'"
                        @click="handleCloseRequested"
                        isPrimary
                    />
                </div>

            </v-stepper-content>
        </v-stepper-items>
    </v-stepper>

</div>
</template>

<script>
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import TextButton from '@/components/ui/button/TextButton.vue';
import AppTextField from '@/components/app/AppTextfield';
import AppDialog from '@/components/app/AppDialog.vue';
import AppSelectList from '@/components/app/AppSelectList.vue';
import { mapState, mapActions } from 'vuex';

import SelectBox from '@/components/asset/SelectBox.vue';
import SocialApi from '@/api/social/SocialApi';

export default {
    name: 'SocialUploadContent',
    components: { TextButtonBlock, AppTextField, SelectBox, AppSelectList,TextButton, AppDialog },
    props: {
        itemName: { type: String, default: null },
        itemTag: { type: [String, Array, Object], default: null },
        filename: { type: String, default: null },
        imageSrc: { type: String, default: '' },
        runtime: { type: String, default: '' },
        standardVal: { type: Object, required: true },
        assetId: { type: [Number, String], default: null },
    },
    data() {
        return {
            e1: 1,
            selectedCard: 'none',
            isChecked: false,
            uploadTitle: null,
            uploadStatus: 'private',
            uploadCate: null,
            uploadDescript: null,
            selectedVideoType: 'video',
            selectedInstagramType: null,
            btnStatus: false,
            overlayVal: false,
            filenameLocal: null,
            currentAssetId: null,
            // 인스타그램, 유튜브브 테스트 연결하기 버튼 - 바로 연결된 UI 이동
            instagramLogin: false,
            integrations: [],
            integrationsLoading: true,
            integrationsError: null,
            privacyItems: [
                {
                    value: 'public',
                    labelKey: 'social.upload.visibility.public',
                    descKey: 'social.upload.visibility.public_desc',
                },
                {
                    value: 'private',
                    labelKey: 'social.upload.visibility.private',
                    descKey: 'social.upload.visibility.private_desc',
                },
                {
                    value: 'unlisted',
                    labelKey: 'social.upload.visibility.unlisted',
                    descKey: 'social.upload.visibility.unlisted_desc',
                },
            ],
            madeForKidsOptions: [
                { value: true, labelKey: 'social.upload.made_for_kids_yes' },
                { value: false, labelKey: 'social.upload.made_for_kids_no' },
            ],
            madeForKids: null,
            selectedChannel: null,
            channelItems: [],
            defaultChannelThumb: require('@/styles/youtube.png'),
            // 위치/사람 태그 UI 상태
            isLocationDialogOpen: false,
            isTagDialogOpen: false,

            selectedLocation: null,
            taggedPeople: [],

            // 검색 바인딩
            locationQuery: '',
            peopleQuery: '',

            // 더미 데이터 (검색 목록)
            locationCandidates: [
                { id: 'l1', name: '홍대입구역', address: '서울 마포구 양화로' },
                { id: 'l2', name: '강남역',   address: '서울 강남구 테헤란로' },
                { id: 'l3', name: '부산 해운대', address: '부산 해운대구 해운대해변로' },
                { id: 'l4', name: '제주 공항', address: '제주 제주시 공항로' },
                { id: 'l5', name: '광화문',   address: '서울 종로구 세종대로' },
                { id: 'l6', name: '탐라카페',  address: '제주 제주시 신대로' },
            ],
            peopleCandidates: [
                { id: 'u1', name: '김하나', handle: '@hana'  ,thumb: 'thum01' },
                { id: 'u2', name: '이미지', handle: '@miji'   ,thumb: 'thum02'},
                { id: 'u3', name: '박태그', handle: '@tagger'   ,thumb: 'thum03'},
                { id: 'u4', name: '홍길동', handle: '@hong'   ,thumb: 'thum04'},
                { id: 'u5', name: '이브이', handle: '@eevee'   ,thumb: 'thum05'},
                { id: 'u6', name: '제이슨', handle: '@jason'   ,thumb: 'thum03'},
                { id: 'u7', name: '브랜드팀', handle: '@brand'   ,thumb: 'thum03'},
                { id: 'u8', name: '김하나', handle: '@hana'  ,thumb: 'thum01' },
                { id: 'u9', name: '이미지', handle: '@miji'   ,thumb: 'thum02'},
                { id: 'u10', name: '박태그', handle: '@tagger'   ,thumb: 'thum03'},
                { id: 'u11', name: '홍길동', handle: '@hong'   ,thumb: 'thum04'},
                { id: 'u12', name: '이브이', handle: '@eevee'   ,thumb: 'thum05'},
                { id: 'u13', name: '제이슨', handle: '@jason'   ,thumb: 'thum03'},
                { id: 'u14', name: '브랜드팀', handle: '@brand'   ,thumb: 'thum03'},
                { id: 'u15', name: '김하나', handle: '@hana'  ,thumb: 'thum01' },
                { id: 'u16', name: '이미지', handle: '@miji'   ,thumb: 'thum02'},
                { id: 'u17', name: '박태그', handle: '@tagger'   ,thumb: 'thum03'},
                { id: 'u18', name: '홍길동', handle: '@hong'   ,thumb: 'thum04'},
                { id: 'u19', name: '이브이', handle: '@eevee'   ,thumb: 'thum05'},
                { id: 'u20', name: '제이슨', handle: '@jason'   ,thumb: 'thum03'},
                { id: 'u21', name: '브랜드팀', handle: '@brand'   ,thumb: 'thum03'},
                { id: 'u22', name: '브랜드팀', handle: '@brand'   ,thumb: 'thum03'},
            ],
            thumbsMap: {
                thum01: require('@/styles/thum01.png'),
                thum02: require('@/styles/thum02.png'),
                thum03: require('@/styles/thum03.png'),
                thum04: require('@/styles/thum04.png'),
                thum05: require('@/styles/thum05.png'),
            },
            officialIcon: require('@/styles/instgram.png'),
            officialIds: ['u1', 'u2'],
            showInCardUploadPanel: true,
            descriptionDirty: false,
            syncingDescriptionFromProp: false,
            youtubeCategories: [],
            youtubeCategoriesLoading: false,
            youtubeCategoriesError: null,
        };
    },
    computed: {
        canUseSocialPublish() {
            return this.$store.getters['naviList/hasSocialPublish'];
        },
        lockBadgeLabel() {
            return this.$store.getters.t ? this.$store.getters.t('common.unlock_required') : '잠금 해제 필요';
        },
        upgradeCopy() {
            return this.$store.getters.t
                ? this.$store.getters.t('social.upload.locked.free_plan_create')
                : '현재 무료 플랜에서는 소셜 업로드 요청을 생성할 수 없습니다. 플랜을 업그레이드하면 멀티 채널 업로드가 활성화됩니다.';
        },
        googleLogin() {
            const googleToken = sessionStorage.getItem('google_access_token');
            return !!googleToken || !!this.youtubeIntegration;
        },
        youtubeIntegration() {
            return (this.integrations || []).find(intg => {
                const key = intg?.platform?.key || intg?.platform?.name;
                return key && key.toLowerCase() === 'youtube';
            }) || null;
        },
        instagramIntegration() {
            return (this.integrations || []).find(intg => {
                const key = intg?.platform?.key || intg?.platform?.name;
                return key && key.toLowerCase() === 'instagram';
            }) || null;
        },
        imageSrcComputed() {
            if (this.imageSrc && this.imageSrc.trim() !== '') return this.imageSrc;
            return 'https://ceph01rgw.streamon.co.kr:47043/streamon01/logo/streamon.png';
        },
        runtimeComputed() {
            const v = this.runtime;
            if (!v) return '';
            return String(v).trim();
        },
        ...mapState('upload', ['socialJobs']),
        uploadJobs() {
            return this.socialJobs;
        },
        activeLanguage() {
            return this.$store.getters.currentLanguage;
        },
        translatedPrivacyItems() {
            return this.privacyItems.map(option => ({
                value: option.value,
                label: this.$store.getters.t(option.labelKey),
                desc: option.descKey ? this.$store.getters.t(option.descKey) : '',
            }));
        },
        madeForKidsSelectItems() {
            return this.madeForKidsOptions.map(option => ({
                label: this.$store.getters.t(option.labelKey),
                value: option.value,
            }));
        },
        youtubeCategoryItems() {
            if (this.youtubeCategories.length) {
                return this.youtubeCategories;
            }
            const fallback = this.standardVal?.youtubeCat || [];
            return fallback
                .map(item => {
                    if (typeof item === 'object') {
                        const label = item.label || item.value || '';
                        const value = item.value || item.label || '';
                        if (!label || !value) return null;
                        return { label, value };
                    }
                    if (item === null || item === undefined) return null;
                    const label = String(item);
                    return { label, value: label };
                })
                .filter(Boolean);
        },
        hasActiveUploads() {
            const activeStatuses = new Set(['uploading', 'processing', 'queued']);
            return this.uploadJobs.some(job => {
                const pct = Number(job.progress ?? 0);
                return activeStatuses.has(job.status) || pct < 100;
            });
        },
        platformLabel() {
            if (this.selectedCard === 'youtube') {
                return this.$store.getters.t('social.upload.platform.youtube');
            }
            if (this.selectedCard === 'instgram') {
                return this.$store.getters.t('social.upload.platform.instagram');
            }
            return '-';
        },
        videoTypeLabel() {
            const map = {
                shorts: this.$store.getters.t('social.upload.youtube.type.shorts_summary'),
                video: this.$store.getters.t('social.upload.youtube.type.video_summary'),
                reels: this.$store.getters.t('social.upload.instagram.type.reels'),
                feed: this.$store.getters.t('social.upload.instagram.type.feed'),
            };
            return map[this.selectedVideoType] || '-';
        },
        privacyLabel() {
            // standardVal.privacyData가 [{label,value}] 또는 ['공개','비공개',..] 둘 다 대응
            const items = this.standardVal?.privacyData || [];
            if (!items.length) return this.uploadStatus || '-';
            if (typeof items[0] === 'object') {
            const f = items.find(x => x.value === this.uploadStatus);
            return f ? f.label : (this.uploadStatus || '-');
            }
            // 문자열 배열일 때
            return this.uploadStatus || '-';
        },
        selectedChannelLabel() {
            // 채널 select v-model이 selectedChannel이라고 가정 (없으면 null 반환)
            const list = this.channelItems || [];
            const found = list.find(x => x.value === this.selectedChannel);
            return found ? found.label : '';
        },
        filteredLocations() {
            const q = this.locationQuery.trim().toLowerCase();
            return q
            ? this.locationCandidates.filter(l =>
                l.name.toLowerCase().includes(q) || l.address.toLowerCase().includes(q)
                )
            : this.locationCandidates;
        },
        filteredPeople() {
            const q = this.peopleQuery.trim().toLowerCase();
            return q
            ? this.peopleCandidates.filter(p =>
                p.name.toLowerCase().includes(q) || p.handle.toLowerCase().includes(q)
                )
            : this.peopleCandidates;
        },
    },
    watch: {
        itemName: {
            handler(val) { this.uploadTitle = val; }, immediate: true,
        },
        itemTag: {
            handler(val) {
                this.applyDescriptionFromProp(val);
            },
            immediate: true,
        },
        filename: {
            handler(val) { this.filenameLocal = val; }, immediate: true,
        },
        assetId: {
            handler(newVal, oldVal) {
                const changed = newVal !== oldVal;
                if (changed) {
                    this.descriptionDirty = false;
                    this.currentAssetId = newVal;
                    this.applyDescriptionFromProp(this.itemTag, { force: true });
                } else if (this.uploadDescript === null || this.uploadDescript === undefined) {
                    this.applyDescriptionFromProp(this.itemTag, { force: true });
                }
            },
            immediate: true,
        },
        activeLanguage: {
            handler() {
                this.fetchYoutubeCategories();
            },
            immediate: true,
        },
    },
  methods: {
        ...mapActions('upload', {
            fetchSocialJobsFromStore: 'fetchSocialJobs',
        }),
        handleNextStep() {
            if (this.selectedCard === 'youtube') {
                if (!this.validateYoutubeStep()) {
                    return;
                }
            }
            this.e1 = 2;
        },
        validateYoutubeStep() {
            if (!this.selectedChannel) {
                alert(this.$store.getters.t
                    ? this.$store.getters.t('social.upload.validation.select_channel')
                    : '연동된 채널을 선택해주세요.');
                return false;
            }

            if (!this.uploadTitle || !this.uploadTitle.trim()) {
                alert(this.$store.getters.t
                    ? this.$store.getters.t('social.upload.validation.enter_title')
                    : '제목을 입력해주세요.');
                return false;
            }

            if (!this.uploadStatus) {
                alert(this.$store.getters.t
                    ? this.$store.getters.t('social.upload.validation.select_visibility')
                    : '공개 범위를 선택해주세요.');
                return false;
            }

            if (this.madeForKids === null || this.madeForKids === undefined) {
                alert(this.$store.getters.t
                    ? this.$store.getters.t('social.upload.validation.select_made_for_kids')
                    : '아동용 콘텐츠 여부를 선택해주세요.');
                return false;
            }

            return true;
        },
        onDescriptionInput() {
            if (this.syncingDescriptionFromProp) return;
            this.descriptionDirty = true;
        },
        applyDescriptionFromProp(value, options = {}) {
            const { force = false } = options;
            const normalized = this.normalizeDescriptionValue(value);
            if (!force) {
                if (this.descriptionDirty) return;
                if (!normalized && this.uploadDescript) return;
                if (normalized === this.uploadDescript) return;
            }
            this.syncingDescriptionFromProp = true;
            this.uploadDescript = normalized;
            this.$nextTick(() => {
                this.syncingDescriptionFromProp = false;
            });
        },
        async fetchYoutubeCategories() {
            const lang = this.activeLanguage || 'ENG';
            this.youtubeCategoriesLoading = true;
            this.youtubeCategoriesError = null;
            try {
                const remoteCategories = await SocialApi.fetchYoutubeCategories({ lang });
                this.youtubeCategories = (remoteCategories || [])
                    .map(item => ({
                        label: item.title || item.id,
                        value: item.id,
                    }))
                    .filter(cat => cat.label && cat.value);

                if (this.youtubeCategories.length && !this.isValidYoutubeCategoryValue(this.uploadCate)) {
                    const first = this.youtubeCategories[0];
                    this.uploadCate = first.value || first.label;
                }
            } catch (error) {
                console.error('[SocialUpload] Failed to load YouTube categories', error);
                this.youtubeCategories = [];
                this.youtubeCategoriesError = this.$store.getters.t
                    ? this.$store.getters.t('social.integration.error.youtube_categories')
                    : '유튜브 카테고리를 불러오지 못했습니다.';
            } finally {
                this.youtubeCategoriesLoading = false;
            }
        },
        isValidYoutubeCategoryValue(value) {
            if (value === null || value === undefined) {
                return false;
            }
            return this.youtubeCategoryItems.some(item => item.value === value || item.label === value);
        },
        async loadIntegrations() {
            this.integrationsLoading = true;
            this.integrationsError = null;
            try {
                const data = await SocialApi.fetchIntegrations();
                this.integrations = Array.isArray(data) ? data : [];
                this.updateChannelItems();
                this.instagramLogin = !!this.instagramIntegration;
            } catch (error) {
                console.error('[SocialUpload] Failed to load integrations', error);
                this.integrationsError = this.$store.getters.t
                    ? this.$store.getters.t('social.integration.error.load_connections')
                    : '소셜 연동 정보를 불러오지 못했습니다.';
                this.integrations = [];
                this.updateChannelItems();
                this.instagramLogin = !!this.instagramIntegration;
            } finally {
                this.integrationsLoading = false;
            }
        },
        updateChannelItems() {
            const youtubeIntegrations = (this.integrations || []).filter(intg => {
                const key = intg?.platform?.key || intg?.platform?.name;
                return key && key.toLowerCase() === 'youtube';
            });

            this.channelItems = youtubeIntegrations.map(intg => {
                const settings = (intg.settings && typeof intg.settings === 'object') ? intg.settings : {};
                const thumb = settings.thumbnail_url || this.defaultChannelThumb;
                const label = intg.external_name || settings.title || intg.platform?.name || 'YouTube Channel';
                return {
                    label,
                    value: intg.id,
                    thumb,
                    needReconnect: (intg.status && intg.status !== 'active'),
                    raw: intg,
                };
            });

            if (this.channelItems.length === 0) {
                this.selectedChannel = null;
                return;
            }

            const exists = this.channelItems.some(item => item.value === this.selectedChannel);
            if (!exists) {
                this.selectedChannel = this.channelItems[0].value;
            }

            if (this.selectedCard === 'none' || this.selectedCard === null) {
                this.selectedCard = 'youtube';
            }
        },
        async connectYouTube() {
            try {
                const response = await SocialApi.beginOAuth('youtube');
                const url = response?.authorization_url;
                if (!url) {
                    throw new Error('YouTube OAuth URL not provided');
                }
                window.open(url, 'streamonSocialOAuth', 'width=520,height=720,menubar=no,toolbar=no,location=no,status=no');
            } catch (error) {
                console.error('[SocialUpload] Failed to start YouTube OAuth', error);
                const message = this.$store.getters.t
                    ? this.$store.getters.t('social.integration.error.youtube_start')
                    : '유튜브 연동을 시작하지 못했습니다.';
                alert(message);
            }
        },
        connectSelected() {
            if (this.$router) this.$router.push('/social/connect');
        },
        onAddChannel() {
            this.connectYouTube();
        },
        async socialUpload() {
            if (!this.canUseSocialPublish) {
                return;
            }
            this.btnStatus = true;
            this.overlayVal = true;
            this.showInCardUploadPanel = true;

            const integrationIdNumeric = Number(this.selectedChannel);
            if (!Number.isFinite(integrationIdNumeric)) {
                this.overlayVal = false;
                this.btnStatus = false;
                alert(this.$store.getters.t ? this.$store.getters.t('social.upload.validation.select_channel') : '연동된 채널을 선택해주세요.');
                return;
            }

            if (!this.assetId) {
                this.overlayVal = false;
                this.btnStatus = false;
                alert(this.$store.getters.t ? this.$store.getters.t('asset.error.not_found') : '자산 정보를 찾을 수 없습니다.');
                return;
            }

            if (this.madeForKids === null) {
                this.overlayVal = false;
                this.btnStatus = false;
                alert(this.$store.getters.t ? this.$store.getters.t('social.upload.validation.select_made_for_kids') : '아동용 콘텐츠 여부를 선택해주세요.');
                return;
            }

            const payload = {
                asset_id: Number(this.assetId),
                integration_ids: [integrationIdNumeric],
                title: this.uploadTitle || this.itemName,
                description: this.normalizeDescriptionValue(this.uploadDescript) || '',
                tags: this.normalizeTags(this.uploadDescript),
                privacy: this.uploadStatus || 'private',
                platform_options: {},
            };

            const youtubeOptions = this.buildYoutubeOptions();
            if (youtubeOptions) {
                payload.platform_options[integrationIdNumeric] = youtubeOptions;
            }

            try {
                const response = await SocialApi.createPublishTasks(payload);
                if (response && response.length) {
                    await this.fetchSocialJobsFromStore();
                    this.e1 = 3;
                    this.$emit('end-upload', response);
                } else {
                    alert(this.$store.getters.t
                        ? this.$store.getters.t('social.upload.error.create_failed')
                        : '소셜 업로드 작업을 생성하지 못했습니다.'
                    );
                }
            } catch (error) {
                console.error(error);
                alert(this.$store.getters.t ? this.$store.getters.t('social.upload.error.generic') : '소셜 업로드 중 오류가 발생했습니다.');
            } finally {
                this.overlayVal = false;
                this.btnStatus = false;
                await this.fetchSocialJobsFromStore();
            }
        },
        onPrivacySelected(newVal) {
            this.uploadStatus = newVal;
        },
        onCateSelected(newVal) {
            this.uploadCate = newVal;
        },
        async selYouTube() {
            if (this.googleLogin) {
                this.selectedCard = 'youtube';
                this.isChecked = true;
            } else {
                await this.connectYouTube();
            }
        },
        selectLocation(loc) {
            this.selectedLocation = loc;  // 1곳 제한
            this.isLocationDialogOpen = false;
        },
        clearLocation() {
            this.selectedLocation = null;
        },

        // 사람 태그
        isAlreadyTagged(id) {
            return this.taggedPeople.some(p => p.id === id);
        },
        isOfficial(entity) {
            if (!entity) return false;
            return !!entity.official || this.officialIds.includes(entity.id);
        },
        toggleTagPerson(p) {
            // kept for compatibility; prefer addTaggedPerson/removeTaggedPerson via buttons
            if (this.isAlreadyTagged(p.id)) return;
            if (this.taggedPeople.length >= 20) return;
            this.taggedPeople = [...this.taggedPeople, p];
        },
        addTaggedPerson(p) {
            if (this.isAlreadyTagged(p.id)) return;
            if (this.taggedPeople.length >= 20) return;
            this.taggedPeople = [...this.taggedPeople, p];
        },
        removeTaggedPerson(id) {
            this.taggedPeople = this.taggedPeople.filter(p => p.id !== id);
        },
        clearAllTagged() {
            this.taggedPeople = [];
        },
        handleOAuthMessage(event) {
            const payload = event?.data;
            if (!payload || payload.type !== 'social-oauth-complete') {
                return;
            }
            this.loadIntegrations();
        },
        normalizeTags(value) {
            if (!value) return [];
            if (Array.isArray(value)) {
                return value.map(v => String(v).trim()).filter(Boolean);
            }
            if (typeof value === 'string') {
                return value
                    .split(/[,#\n]/)
                    .map(v => v.trim())
                    .filter(Boolean);
            }
            return [];
        },
        normalizeDescriptionValue(value) {
            if (value === null || value === undefined) {
                return '';
            }

            if (typeof value === 'string') {
                return value;
            }

            if (Array.isArray(value)) {
                return value
                    .map(v => (typeof v === 'string' ? v : (v?.tag_name || v?.name || '')))
                    .filter(Boolean)
                    .join(', ');
            }

            if (typeof value === 'object') {
                return Object.values(value)
                    .map(v => (typeof v === 'string' ? v : ''))
                    .filter(Boolean)
                    .join(', ');
            }

            return String(value);
        },
        buildYoutubeOptions() {
            if (!this.youtubeIntegration) {
                return null;
            }
            const categoryId = this.getYoutubeCategoryId(this.uploadCate);

            return {
                category_id: categoryId,
                made_for_kids: this.madeForKids,
            };
        },
        getYoutubeCategoryId(label) {
            const categories = this.youtubeCategoryItems || [];
            if (Array.isArray(categories)) {
                const matched = categories.find(cat => cat === label || cat?.label === label || cat?.value === label);
                if (matched && typeof matched === 'object') {
                    return matched.value || matched.id || null;
                }
                if (typeof matched === 'string') {
                    return this.mapCategoryNameToId(matched);
                }
            }
            return this.mapCategoryNameToId(label);
        },
        mapCategoryNameToId(name) {
            const mapper = {
                '영화': 1,
                '자동차': 2,
                '음악': 10,
                '동물': 15,
                '스포츠': 17,
                '여행/이벤트': 19,
                '게임': 20,
                '인물/블로그': 22,
                '코믹/유머': 23,
                '엔터테인먼트': 24,
                '뉴스/정치': 25,
                '노하우/스타일': 26,
                '교육': 27,
                '과학기술': 28,
                '비영리/사회운동': 29,
            };

            if (!name) {
                return null;
            }

            const key = name.toString().trim();
            if (mapper[key]) {
                return mapper[key];
            }

            const numeric = Number(key);
            return Number.isFinite(numeric) ? numeric : null;
        },
        closeInCardUploads() {
            this.showInCardUploadPanel = false;
        },
        handleCloseRequested() {
            this.resetWizard();
            this.$emit('request-close');
            this.$emit('close');
        },
        resetWizard() {
            this.e1 = 1;
            this.showInCardUploadPanel = true;
            if (this.youtubeIntegration) {
                this.selectedCard = 'youtube';
            } else if (this.instagramIntegration) {
                this.selectedCard = 'instgram';
            } else {
                this.selectedCard = 'none';
            }
            if (this.channelItems.length > 0) {
                this.selectedChannel = this.channelItems[0].value;
            } else {
                this.selectedChannel = null;
            }
            const categories = this.youtubeCategoryItems || [];
            if (categories.length) {
                const first = categories[0];
                this.uploadCate = typeof first === 'object' ? (first.value || first.label || first) : first;
            }
            this.madeForKids = null;
            this.descriptionDirty = false;
            this.applyDescriptionFromProp(this.itemTag, { force: true });
        },
    },
    mounted() {
        this.loadIntegrations();
        this.fetchYoutubeCategories();
        this.resetWizard();
        window.addEventListener('message', this.handleOAuthMessage);
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleOAuthMessage);
    },
};
</script>

<style scoped>
.upload-content {
    display: grid;
    grid-template-columns: 320px 1fr; /* 좌측 고정폭, 우측 유동 */
    column-gap: 20px;
    margin-bottom: 20px;
    align-items: start; /* 상단 정렬 */
}
.required-mark {
    color: #d33333;
    margin-left: 4px;
}

/* left 내부는 굳이 grid 쓸 필요 없음 */
.upload-content .left {
  display: block;
  width: 100%;
}
.btn-group {
    display: flex;
    gap: 12px;
}
.upload-action-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-start;
}
.upload-cta-wrapper {
    position: relative;
    flex: 1;
    min-width: 200px;
}
.upload-lock-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 10px;
    background: rgba(229, 231, 235, 0.9);
    border: 1px solid #cbd5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: #4b5563;
    pointer-events: none;
}
.plan-hint {
    padding: 12px 16px;
    border-radius: 10px;
    background: #f3f4f6;
    color: #4b5563;
    font-size: 13px;
    border: 1px solid #e5e7eb;
}
.social_card_group{
    display: flex;
    gap:12px;
    margin-top: 12px;
}
.social_card_group .v-card {
  height: 96px; /* 필요에 맞게 84~112px 사이 추천 */
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.social_card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-align: center;
}

.social_card h4 {
  margin: 0;
  white-space: nowrap;       /* 줄바꿈 방지 (폭 줄어도 높이 안 늘어나게) */
}
.social_card .social_card_img {
    width: 40px;
    height: 40px;
}
.social_card_icon {
    font-size: 40px;
}
.detail_Card{
    width: 100%;
    height: 100%;
}
.media_none {
    height: 100%;
    padding: 0 36px;
    display: grid;
    align-items: center;
}
.media_none_contents {
    width:100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    text-align: center;
}
.media_none_contents hr {
    color: #ccc;
}
.media_none_contents > hr {
    align-self: stretch;
    width: 100%;
    border: 0;
    border-top: 1px solid #ccc;
    margin: 4px 0;
}
.media_none_contents > img {
    display: block;
    width: 50px !important;
    height: 50px !important;
    object-fit: contain;
}

/* Tailwind-like feel enhancements */
.social_card_group .v-card {
    border-radius: 6px !important;
    transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
}
.social_card_group .v-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0,0,0,0.12) !important;
}
.social_card_group .v-card.selected {
    background-color: #fafafa;
    border-color: #c7d2fe !important;
}
.social_card_group > .v-card:nth-child(1).selected {
    /* YouTube */
    border-color: #ef4444 !important;
    background-color: #fee2e2;
}
.social_card_group > .v-card:nth-child(2).selected {
    /* Instagram */
    border-color: #a855f7 !important;
    background-color: #f3e8ff;
}

/* Inputs and textareas (Vuetify) */
::v-deep(.v-text-field.v-text-field--outlined .v-input__slot) {
    border-radius: 6px !important;
    border-color: #e5e7eb !important; /* gray-200 */
}
::v-deep(.v-text-field.v-text-field--outlined:hover .v-input__slot) {
    border-color: #cbd5e1 !important; /* gray-300 */
}
::v-deep(.v-text-field.v-text-field--outlined.v-input--is-focused .v-input__slot) {
    border-color: #ef4444 !important; /* red-500 */
    box-shadow: 0 0 0 3px rgba(239,68,68,.15) !important;
}

/* AppTextField input */
::v-deep(input.search-input) {
    border-radius: 6px !important;
    height: 42px !important;
    padding: 10px 12px !important;
    font-size: 14px !important;
}
::v-deep(input.search-input:focus) {
    border-color: #6366f1 !important; /* indigo-500 */
    box-shadow: 0 0 0 3px rgba(99,102,241,.2) !important;
}

/* Section spacing and toggles */
.youtubetype h4, .instagramtype h4 { margin: 8px 0 8px; }


.type-toggle {
  display: flex;
  gap: 12px;
}

.type-card {
  flex: 1;
  cursor: pointer;
  border-radius: 10px !important;
  transition: all 0.2s ease;
  border: 1.5px solid #e5e7eb !important;
  background-color: #fff;
}

.type-card:hover {
  border-color: #b0b0b0 !important;
}

.type-card.active {
  border-color: #ccc !important;
  background-color: #ececec;
}

.type-card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  gap: 4px;
}

.type-title {
  font-weight: 700;
  font-size: 15px;
  color: #111827;
}

.type-sub {
  font-size: 13px;
  color: #6b7280;
}

.description {
    height: 112px;
}

.success-circle {
  width: 52px; height: 52px;
  border-radius: 9999px;
  background: #e8f5e9; /* green-50 */
  display: flex; align-items: center; justify-content: center;
  font-size: 28px;
}

.summary-card {
  background: #f9fafb; /* gray-50 */
  border-radius: 12px;
  padding: 12px 14px;
  margin-top: 12px;
}

.summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
}
.summary-row:last-child { border-bottom: 0; }

.summary-key {
  font-size: 13px;
  color: #6b7280; /* gray-500 */
  font-weight: 600;
}
.summary-val {
  font-size: 14px;
  color: #111827; /* gray-900 */
  max-width: 70%;
  text-align: right;
}
.summary-ellipsis {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.upload_check {
    display: grid;
    align-items: center;
}

.meta-wrap {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}
.meta-block { display: flex;flex-direction: column;border: 1px solid #e5e7eb; border-radius: 10px; padding: 14px; background: #fff; }
.meta-head { display: flex; align-items: baseline; gap: 8px; }
.meta-title { font-weight: 800; color: #111827; }
.meta-hint { font-size: 12px; color: #6b7280; }
.meta-empty { font-size: 12px; color: #9ca3af; }
.meta-actions { margin-top: 8px; display:flex; align-items:center; }
.counter { font-size: 12px; color:#6b7280; }

.chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 4px 0;
    max-height: 90px;
    overflow-y: auto;
    scrollbar-width: thin;
}

/* 크롬용 스크롤바 커스터마이즈 */
.chips::-webkit-scrollbar {
  width: 6px;
}
.chips::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.chips::-webkit-scrollbar-track {
  background: transparent;
}

.chip-item { background: #f3f4f6 !important; }
.chip-close { cursor: pointer; margin-left: 4px; }

.list-wrap {
    min-height: 216px;
    max-height: 216px; /* 4.5개 정도 보이도록 (약 item-height 48 기준) */
    overflow-y: auto;
    height: auto;
    border: 1px solid #e5e7eb; border-radius: 8px;
}

.chip-person {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.chip-text {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.chip-name { font-weight: 600; }
.chip-handle { color: #6b7280; font-size: 12px; margin-left: 4px; }
.official-mark { display: inline-block; vertical-align: middle; }
.limit-hint { margin-top: 8px; font-size: 12px; color: #ef4444; }

.meta-actions-btn { border-color: #ccc !important }

.media_error_contents {
  padding: 24px;
}
.error-steps {
  text-align: left;
  margin: 16px auto 0;
  padding-left: 18px;
  max-width: 560px;
}
.step-title { font-weight: 600; margin-bottom: 4px; }
.step-desc { color: #666; margin-bottom: 6px; }
.step-link { font-weight: 600; text-decoration: underline; }

.chip_posi { position: absolute; top: 8px; left: 8px; padding: 6px;}
</style>

<style scoped>
.upload-step-complete { display: flex; flex-direction: column; gap: 24px; }
.upload-complete-card { border: 1px solid #e5e7eb; border-radius: 12px; padding: 24px; text-align: center; background: #ffffff; }
.success-circle { width: 64px; height: 64px; border-radius: 50%; background: #ecfdf5; display:flex; align-items:center; justify-content:center; margin: 0 auto 16px; }
.complete-title { font-size: 18px; font-weight: 700; color: #111827; margin-bottom: 8px; }
.complete-desc { font-size: 14px; color: #6b7280; margin-bottom: 16px; white-space: pre-line; }
.video-duration {
  position: absolute;
  right: 8px;
  bottom: 8px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.2;
  z-index: 2;
}
.thum_cover { width: 30px !important; }
</style>
